/* Moved from sections/cb-review-wall.liquid on 2026-10-22 (page weight): cached and deferred, never inline. */
if (!customElements.get('cb-review-wall')) {
    customElements.define(
      'cb-review-wall',
      class extends HTMLElement {
        connectedCallback() {
          this.grid = this.querySelector('[data-cb-grid]');
          if (!this.grid) return;
          this.cards = Array.from(this.grid.querySelectorAll('.cb-rw__card'));
          this.button = this.querySelector('.cb-rw__more');
          this.onChange = () => this.layout();
          this.queries = [750, 1100].map((width) => window.matchMedia(`(min-width: ${width}px)`));
          this.queries.forEach((query) => query.addEventListener('change', this.onChange));
          this.onMore = () => this.more();
          this.button?.addEventListener('click', this.onMore);
          this.layout();
        }

        disconnectedCallback() {
          this.queries?.forEach((query) => query.removeEventListener('change', this.onChange));
          this.button?.removeEventListener('click', this.onMore);
        }

        /* Masonry in reading order: each shown card goes into the shortest column. */
        layout() {
          const count = parseInt(getComputedStyle(this.grid).getPropertyValue('--cb-rw-cols'), 10) || 2;
          this.cards.forEach((card) => this.grid.append(card));
          this.grid.querySelectorAll(':scope > .cb-rw__col').forEach((column) => column.remove());
          this.columns = Array.from({ length: count }, () => {
            const column = document.createElement('div');
            column.className = 'cb-rw__col';
            return column;
          });
          this.grid.prepend(...this.columns);
          this.grid.classList.add('is-masonry');
          this.cards.filter((card) => !card.hidden).forEach((card) => this.place(card));
        }

        place(card) {
          const shortest = this.columns.reduce((a, b) => (b.offsetHeight < a.offsetHeight ? b : a));
          shortest.append(card);
        }

        more() {
          const step = Number(this.dataset.step) || 8;
          const waiting = this.cards.filter((card) => card.hidden);
          waiting.slice(0, step).forEach((card) => {
            card.hidden = false;
            this.place(card);
          });
          if (waiting.length <= step) this.button.closest('.cb-rw__more-wrap').hidden = true;
        }
      }
    );
  }
